import styled from 'styled-components';

export const DoneWrapper = styled.div`
  font-size: 19px;
  font-weight: 800;
  text-align: left;

  @media (max-width: 991px) {
    margin-top: 24px;
    text-align: center;
  }
`;

export const ZoomImageContainer = styled.div`
  position: relative;
  img {
    &:hover {
      cursor: zoom-in;
    }
  }
`;
